// ─────────────────────────────────────────────────────────────────
// songsData.js  –  Static playlist data for LoveworldSingers page
// All YouTube IDs verified from search results — no guessed IDs.
// ─────────────────────────────────────────────────────────────────

export const GENRES = [
  { id: 'praise',  label: 'Praise Night', color: '#ffd700', icon: '🔥' },
  { id: 'worship', label: 'Worship',      color: '#4d4dff', icon: '🙌' },
  { id: 'healing', label: 'Healing',      color: '#00ff88', icon: '💚' },
];

// ── PRAISE NIGHT ─────────────────────────────────────────────────
const praiseNight = [
  {
    id: 101,
    genre: 'praise',
    title: 'Holy Holy God Almighty',
    artist: 'Pastor Saki & Loveworld Singers',
    category: 'Praise Night',
    icon: '🔥',
    youtubeId: 'kQt7IGio5bU',
    description: 'A powerful declaration of God\'s holiness as all creation joins the angels in worship.',
    lyrics: [
      'HOLY HOLY GOD ALMIGHTY',
      'Pastor Saki & Loveworld Singers',
      '',
      'Holy, Holy',
      'God Almighty',
      'We join the angels',
      'As we worship You',
      '',
      'Worthy, worthy',
      'God Almighty',
      'All creation proclaim that You are King',
      '',
      'Holy, Holy',
      'God Almighty',
      'We join the angels',
      'As we worship You',
      '',
      'Worthy, worthy',
      'God Almighty',
      'All creation sing Your praise',
      '',
      'As we worship You',
      'Holy is the Lamb',
      'We join the angels',
      'And will sing Your praise',
      '',
      'Every nation',
      'Every tongue',
      'Every people',
      'Every tribe',
      '',
      'Holy, Holy God Almighty',
      'Holy, Holy God Almighty',
      'We join the angels as we worship You',
      '',
      'Holy is the Lamb',
      'We join the angels',
      'Will sing Your praise',
    ].join('\n'),
    teachingNotes: [
      'Key: D major. Tempo: Moderate, majestic.',
      'Start with a gentle build on "Holy, Holy" before the full congregation joins.',
      'Dynamics: swell on "All creation proclaim".',
      'Choir tip: Round the "O" vowels on "Holy" — it should resonate, not clip.',
      'Bridge: slow down on "Every nation, Every tongue" to let it land.',
      'Instruments: Organ pad underneath for depth; piano carries the melody.',
    ].join('\n'),
  },

  {
    id: 102,
    genre: 'praise',
    title: 'Governments and Galaxies',
    artist: 'Pastor Saki & Loveworld Singers',
    category: 'Praise Night',
    icon: '🔥',
    youtubeId: '8pgH6TZJkPk',
    description: 'A jubilant proclamation that the whole world and all galaxies belong to the Holy God.',
    lyrics: [
      'GOVERNMENTS AND GALAXIES',
      'Pastor Saki & Loveworld Singers',
      '',
      'Hallelujah!',
      'Just lift your hands and glorify God',
      'We worship You Lord',
      '',
      'The whole world belongs to You',
      'Governments and Galaxies',
      'You are Holy, Holy God',
      '',
      'The nations belong to You',
      'You are God of everything',
      'You are Holy, Holy God',
      '',
      'You are the God of miracles',
      'Who was and is to come',
      'All power belong to You almighty God',
      '',
      'You are the one who says a thing',
      'And it surely comes to pass',
      'We bow before Your throne',
      'Almighty God',
      '',
      'You are Holy, Holy God',
      'You are Holy, Holy God',
      'Holy, Holy, Holy, Holy God',
      '',
      'Hallelujah!',
      'Hallelujah!',
      'Hallelujah to the King!',
    ].join('\n'),
    teachingNotes: [
      'Key: Bb major. Upbeat praise tempo — keep the energy high.',
      'Open with hand-clapping on the intro to set the atmosphere.',
      '"Governments and Galaxies" — God\'s sovereignty over earthly powers and the universe.',
      'Dynamics: Full band on chorus. Pull back on verse 2 for contrast.',
      'Encourage movement in the congregation from the first bar.',
    ].join('\n'),
  },

  {
    id: 103,
    genre: 'praise',
    title: 'Holy, Most Holy',
    artist: 'Maya & Loveworld Singers',
    category: 'Praise Night',
    icon: '🔥',
    youtubeId: 'QMAOIxoyPIs',
    description: 'A majestic anthem declaring God\'s holiness from heaven to earth, for all eternity — from Praise Night 20.',
    lyrics: [
      'HOLY, MOST HOLY',
      'Maya & Loveworld Singers — Praise Night 20',
      '',
      'Holy, oh God, You are Lord',
      'You\'re majestic in all Your ways',
      'Hallowed is Your name',
      'In heaven and earth for eternity',
      '',
      'Creator of all things',
      'Time and eternity',
      'The Eternal Being',
      'In whom eternity resides',
      '',
      'You dwell in the highest place',
      'Of endless glory',
      'The deepest depth below',
      'Trembles at Your presence',
      '',
      'The glory of Your presence far surpasses',
      'The widest width and farthest beyond',
      '',
      'Great King and God',
      'Of all the heavens and the earth',
      'Your dynasty reigns through all',
      '',
      'Hallelujah to the Most High God',
      'Hallelujah!',
      'Hallelujah, Hallelujah, Hallelujah',
      'Hallelujah, Hallelujah, Hallelujah',
    ].join('\n'),
    teachingNotes: [
      'Key: G major. Reverent, slow build.',
      '"The Eternal Being in whom eternity resides" — worth a brief teaching moment.',
      'Vocal texture: Sopranos lead the verse; full choir explodes on "Hallelujah to the Most High God".',
      'Intro: piano arpeggios only; strings enter on verse 2.',
      'Final Hallelujah: consider a key change (+1 half step) for maximum impact.',
    ].join('\n'),
  },

   {
    id: 104,
    genre: 'praise',
    title: 'Creator of the Universe',
    artist: 'Sylvia & Loveworld Singers',
    category: 'Worship',
    icon: '🙌',
    youtubeId: 'yKuGQwGeT8c',
    description: 'An exalting declaration to the Creator and King of all the earth — the great I AM.',
    lyrics: [
      'CREATOR OF THE UNIVERSE',
      'Sylvia & Loveworld Singers',
      '',
      'Oh Lord our God',
      'Creator of the universe',
      'King of all the earth',
      'The great I AM',
      '',
      'For all the wondrous things You\'ve done',
      'We glorify Your name',
      'For Your love and grace',
      'We worship You',
      '',
      'You set the stars in place',
      'You formed the mountains high',
      'Your glory fills the earth',
      'And reaches to the sky',
      '',
      'Creator of the universe',
      'We bow before Your throne',
      'Creator of all things',
      'Your kingdom shall not end',
      '',
      'You spoke and worlds were formed',
      'You breathed and life began',
      'From the rising of the sun',
      'To where it sets again',
      '',
      'Your greatness has no end',
      'Your love will never fail',
      'Forever You will reign',
      'And Your glory will prevail',
      '',
      'Creator of the universe',
      'We bow before Your throne',
      'Creator of all things',
      'Your kingdom shall not end',
    ].join('\n'),
    teachingNotes: [
      'Key: A major. Majestic, moderate tempo.',
      'A creation-praise song — excellent for Sunday worship openers and special events.',
      '"You spoke and worlds were formed" references Genesis 1.',
      'Dynamics: Verse 1 restrained; massive crescendo on the chorus.',
      'Drums enter only from verse 2 to maintain the reverent build.',
      'Choir arrangement: SAT harmony works beautifully on the final chorus.',
    ].join('\n'),
  },

   {
    id: 105,
    genre: 'praise',
    title: 'In Your Image',
    artist: 'Sylvia & Loveworld Singers',
    category: 'Worship',
    icon: '🙌',
    youtubeId: 'LvT427vAkvM',
    description: 'A reflective worship song on identity in Christ — created in His image, sustained by His word.',
    lyrics: [
      'IN YOUR IMAGE',
      'Sylvia & Loveworld Singers',
      '',
      'You search my heart and know me well',
      'You know when I lie and when I rise',
      'You are familiar with all my ways',
      'You know my journey, You\'re my path',
      '',
      'I\'m grateful, Lord, I\'m precious in Your sight',
      'I\'m grateful, Lord, You\'re mindful of me',
      'I\'m grateful, Lord, I\'m precious in Your sight',
      'I\'m grateful, Lord, You\'re mindful of me',
      '',
      'In Your image',
      'I was made',
      'In Your image',
      'You breathed life',
      '',
      'In Your image',
      'I reflect Your glory',
      'In Your image',
      'Forever',
      '',
      'Lord, I worship You',
      'With everything within me',
      'Lord, I adore You',
      'Every day, in every way',
      '',
      'Nothing in this world compares',
      'To who You are',
      'In Your image',
      'You made me',
    ].join('\n'),
    teachingNotes: [
      'Key: E major. Mid-tempo worship.',
      'Theme: Identity in Christ — great for personal reflection and congregational declaration.',
      'Verse should feel personal and intimate; bridge is a corporate declaration.',
      'Encourage singers to sing with personal conviction — this is a testimony song.',
      'Instrumentation: Acoustic guitar on intro; keys and bass join at verse 2.',
    ].join('\n'),
  },
  
];

// ── WORSHIP ───────────────────────────────────────────────────────
const worship = [
  {
    id: 201,
    genre: 'worship',
    title: 'Holy God',
    artist: 'Evang. Kathy & Loveworld Singers',
    category: 'Worship',
    icon: '🙌',
    youtubeId: 'lhC_HdXy568',
    description: 'A tender worship song declaring God\'s holiness and greatness with bilingual English-Hindi lyrics.',
    lyrics: [
      'HOLY GOD',
      'Written by Evang. Kathy',
      '',
      'Verse 1:',
      'Lord You reign forever',
      '(Prabhu Aap raaj karte sadaa)',
      'Your throne is forever',
      '(Sinhasan aapka sadaa kaa)',
      'King for all ages',
      '(Sabhi yugon ke raja)',
      'You\'re enthroned forever',
      '(Aap virajmaan hain sadaa)',
      '',
      'Chorus:',
      'Holy God',
      '(Paak Khudaa)',
      'Holy God',
      '(Paak Khudaa)',
      'You are great',
      '(Aap hain mahaan)',
      'Holy God',
      '(Paak Khudaa)',
      'Holy God',
      '(Paak Khudaa)',
      'You are great',
      '(Aap hain mahaan)',
      '',
      'Verse 2:',
      'As a sacrifice',
      '(Ek balidaan jaise)',
      'Our praise to You we offer',
      '(Stuti hum aapko dete)',
      'Merciful and gracious',
      '(Dayaalu aur kripalu)',
      'Great God Almighty',
      '(Prabhu mahaan saarthi)',
      '',
      'As a sweet incense',
      '(Ek madhur dhoop ki tarah)',
      'Let our praises be',
      '(Stuti hamari ho)',
      '',
      'Chorus:',
      'Unto You',
      '(Aapke liye)',
      'Holy God',
      '(Paak Khudaa)',
      'You are great',
      '(Aap hain mahaan)',
      '',
      'Pan:',
      'Ho o o o o holy God',
      '(Paak Khudaa)',
      'Ha a a a a hallelujah',
      '(Haleluyaah)',
    ].join('\n'),
    teachingNotes: [
      'Key: C major. Tempo: Slow, reverent.',
      'Hindi pronunciation guide:',
      '  "Paak Khuda" = Holy God',
      '  "Aap hain Mahaan" = You are great',
      'Start soft and intimate in Verse 1.',
      'Swell on "Holy God" in the chorus — keep vowels open and round on "Ho-ly".',
      'Chord progression: C – G – Am – F throughout.',
      'Consider a half-step modulation on the final chorus.',
      'Teach congregation the Hindi response lines before singing.',
    ].join('\n'),
  },

  {
  id: 202,
  genre: 'worship',
  title: 'Medley 4',
  artist: '...',
  category: 'Worship',
  icon: '🙌',
  youtubeId: 'IThshKLCkBg',
  description: '...',
  lyrics: [
    '...'
  ].join('\n'),
  teachingNotes: [
    '...'
  ].join('\n'),
},

  {
    id: 203,
    genre: 'worship',
    title: 'Creator of the Universe',
    artist: 'Sylvia & Loveworld Singers',
    category: 'Worship',
    icon: '🙌',
    youtubeId: 'yKuGQwGeT8c',
    description: 'An exalting declaration to the Creator and King of all the earth — the great I AM.',
    lyrics: [
      'CREATOR OF THE UNIVERSE',
      'Sylvia & Loveworld Singers',
      '',
      'Oh Lord our God',
      'Creator of the universe',
      'King of all the earth',
      'The great I AM',
      '',
      'For all the wondrous things You\'ve done',
      'We glorify Your name',
      'For Your love and grace',
      'We worship You',
      '',
      'You set the stars in place',
      'You formed the mountains high',
      'Your glory fills the earth',
      'And reaches to the sky',
      '',
      'Creator of the universe',
      'We bow before Your throne',
      'Creator of all things',
      'Your kingdom shall not end',
      '',
      'You spoke and worlds were formed',
      'You breathed and life began',
      'From the rising of the sun',
      'To where it sets again',
      '',
      'Your greatness has no end',
      'Your love will never fail',
      'Forever You will reign',
      'And Your glory will prevail',
      '',
      'Creator of the universe',
      'We bow before Your throne',
      'Creator of all things',
      'Your kingdom shall not end',
    ].join('\n'),
    teachingNotes: [
      'Key: A major. Majestic, moderate tempo.',
      'A creation-praise song — excellent for Sunday worship openers and special events.',
      '"You spoke and worlds were formed" references Genesis 1.',
      'Dynamics: Verse 1 restrained; massive crescendo on the chorus.',
      'Drums enter only from verse 2 to maintain the reverent build.',
      'Choir arrangement: SAT harmony works beautifully on the final chorus.',
    ].join('\n'),
  },
];

// ── HEALING ───────────────────────────────────────────────────────
const healing = [
  {
    id: 301,
    genre: 'healing',
    title: 'Healing Is Yours',
    artist: 'Alex & Loveworld Singers',
    category: 'Healing',
    icon: '💚',
    youtubeId: 'PaQKYp-bMvg',
    description: 'A faith-filled song declaring the healing power of Jesus — believe it, receive it.',
    lyrics: [
      'HEALING IS YOURS',
      'Alex & Loveworld Singers',
      '',
      'Your miracle is sure today',
      'It doesn\'t matter what it is',
      'There\'s power in the name of Jesus',
      'His name has all authority',
      '',
      'Your miracle is sure today',
      'It doesn\'t matter what it is',
      'There\'s power in the name of Jesus',
      'His name has all authority',
      '',
      'Healing is yours',
      'Healing is yours',
      'Believe it, receive it',
      'Jesus is here',
      'His power is here',
      'He loves you',
      'He wants you well',
      '',
      'Healing is yours',
      'Healing is yours',
      'Believe it, receive it',
      'Jesus is here',
      'His power is here',
      'He loves you and wants you well',
      '',
      'He healed the sick',
      'He raised the dead',
      'He opened blinded eyes',
      'He\'s the same today',
      'His power still remains',
      'Receive your miracle',
    ].join('\n'),
    teachingNotes: [
      'Key: F major. Moderate, faith-filled tempo.',
      'Sing expectantly — not as a request but as a faith affirmation.',
      'Reference: Isaiah 53:5 "By His stripes we are healed."',
      'Congregation tip: Encourage people to place hands on themselves while singing.',
      'Repeat the chorus as needed during altar calls at Healing Streams events.',
    ].join('\n'),
  },

  {
    id: 302,
    genre: 'healing',
    title: 'Enthroned Above All',
    artist: 'Simeon Rich & Loveworld Singers',
    category: 'Healing',
    icon: '💚',
    youtubeId: 'Z-IxC8hmSQI',
    description: 'A triumphant song declaring Jesus enthroned above every principality, power, sickness and circumstance.',
    lyrics: [
      'ENTHRONED ABOVE ALL',
      'Simeon Rich & Loveworld Singers',
      '',
      'You\'re the profile of the Father',
      'Radiant with grace, You\'re reality',
      'By Your decree, all things came to be',
      '',
      'You have preeminence over all things',
      'You rule the nations with awesome power',
      'Your Kingdom is established',
      'Now and forever',
      '',
      'Great and awesome God',
      'You are Living Word',
      'You uphold creation',
      'Your power is supreme',
      'And Your Lordship has no bounds',
      '',
      'The embodiment of wisdom',
      'And knowledge, You are',
      'Holy and gracious King',
      'Enthroned above all',
      '',
      'Mighty are Your deeds',
      'None can defy Your imperial power',
      'Of Your kingship and lordship',
      'There\'s no end',
      '',
      'You are the head of the glorious Church',
      'Your Kingdom is established',
      'Now and forever',
      '',
      'You\'re the most lofty One',
      'No power is exempt from Your rule',
      'Lord, You stand in glory and might',
      'Your reign transcends time',
      '',
      'Enthroned above all',
      'Enthroned above all',
      'Holy and gracious King',
      'Enthroned above all',
    ].join('\n'),
    teachingNotes: [
      'Key: Bb major. Upbeat, triumphant.',
      'Perfect for breakthrough moments during Healing Streams — declare victory over sickness.',
      'Reference: Philippians 2:9-10 "At the name of Jesus every knee shall bow."',
      'Dynamics: Build verse by verse; final chorus full choir and congregation.',
      'Instruments: Strong brass or synth brass adds to the triumphal sound.',
    ].join('\n'),
  },

  {
    id: 303,
    genre: 'healing',
    title: 'Jesus Loves to See You Well',
    artist: 'Obi Shine & Loveworld Singers',
    category: 'Healing',
    icon: '💚',
    youtubeId: 'CLGlSN3NSUo',
    description: 'A joyful, tender song from Healing Streams 13 — Jesus desires healing and wholeness for every person.',
    lyrics: [
      'JESUS LOVES TO SEE YOU WELL',
      'Obi Shine & Loveworld Singers — Healing Streams 13',
      '',
      'Jesus loves to see you well',
      'He wants you whole and free',
      'Jesus loves to see you well',
      'This is His will for thee',
      '',
      'He healed the lame, He raised the dead',
      'He made the blind man see',
      'Jesus is the same today',
      'He\'ll do the same for me and you',
      '',
      'Jesus loves to see you well',
      'He paid the price on Calvary',
      'Jesus loves to see you well',
      'His healing sets you free',
      '',
      'Don\'t be afraid, don\'t be dismayed',
      'He\'s right here by your side',
      'Every sickness, every pain',
      'In His presence cannot hide',
      '',
      'He stretched His hands and touched their lives',
      'He spoke and they were healed',
      'Today He speaks that word to you',
      'His love and grace revealed',
      '',
      'Receive it now',
      'Receive it by faith',
      'Receive your miracle',
      'Jesus makes a way',
    ].join('\n'),
    teachingNotes: [
      'Key: G major. Joyful, moderate-upbeat.',
      'Ideal for pre-prayer moments at Healing Streams — pastoral and gentle.',
      'Call-and-response: leader sings "Jesus loves to see you well" — congregation responds "He wants you whole and free".',
      'Final section: slow down on "Receive it now, Receive it by faith" — prayerful moment.',
      'Tone: warm, reassuring. Let tenderness lead.',
    ].join('\n'),
  },
];

export const SONGS = [...praiseNight, ...worship, ...healing];

export default SONGS; 